export default __webpack_public_path__ + "static/media/Brookshire Brothers Benefits Counselor Schedule 2025_latest.182b6f6d.pdf";